let tabs = document.querySelectorAll('.new-collection .title-wrap .title');
tabs.forEach(item => {
    // if(item)
   item.addEventListener('click', (e) => {
        // 移除所有tab的active类
        tabs.forEach(tab => tab.classList.remove('active'));

        // 添加点击的tab的active类
        item.classList.add('active');

        // 获取点击tab的data-id属性值
        const dataId = item.getAttribute('data-id');

        // 隐藏所有与tab相关的内容块
        const contentBlocks = document.querySelectorAll('.new-collection slider-component');
        contentBlocks.forEach(block => block.style.display = 'none');

        // 显示与点击tab相关的内容块
        const targetBlock = document.querySelector(`slider-component[data-id="${dataId}-block"]`);
        if (targetBlock) {
            targetBlock.style.display = 'block';
        }
   })
})